import BaseService from './base.service'

class RepairService extends BaseService {
    getRepairs() {
        return new Promise((resolve, reject) => {
            return this.request().post({
                method: 'Repair.getRepairs',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }
}

export default new RepairService()
